<template>
    <main class="login">
        <p class="notfound text-center">404 error</p>
        <p class="text-center">Sorry, this page was not found. In a few seconds, you will be redirected to the Home page.</p>
    </main>
</template>

<script>
export default {
    name: 'notfound',
    data: function () {
        return {
        }
    },
    mounted: function() {
        let router = this.$router
        setTimeout(function(){
            router.push({path:'/'})
        }, 5000);
	},
    methods: {

    }
}

</script>
